import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, MessageCircle, Users, Star } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative min-h-[100svh] flex items-center pt-32 pb-20 lg:pt-40 lg:pb-32 overflow-hidden" data-id="element-202">
      {/* Cinematic Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-203">
        <motion.img initial={{
        scale: 1.08
      }} animate={{
        scale: 1
      }} transition={{
        duration: 2.4,
        ease: [0.22, 1, 0.36, 1]
      }} src="https://cdn.magicpatterns.com/uploads/b6CvXM4TRPyzDyzsNAvnEL/nano-banana-2_A_cinematic_portrait_photograph_of_Cinematic_hero_banner_16_9_aspect_ratio._A_co-0_(1).jpg" alt="Nacho Gomez - Especialista en Diseño Web" className="w-full h-full object-cover object-[75%_center] sm:object-[72%_center] lg:object-[68%_center]" data-id="element-204" />

        {/* Cinematic Gradient Overlays */}
        {/* Mobile: left-dark to right-light so text stays legible on left and face shows on right */}
        <div className="absolute inset-0 bg-gradient-to-r from-brand-dark via-brand-dark/85 to-brand-dark/20 lg:hidden" data-id="element-205" />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-dark/70 via-transparent to-transparent lg:hidden" data-id="element-206" />
        {/* Desktop: left-to-right cinematic fade */}
        <div className="hidden lg:block absolute inset-0 bg-gradient-to-r from-brand-dark via-brand-dark/85 to-brand-dark/10" data-id="element-207" />
        <div className="hidden lg:block absolute inset-0 bg-gradient-to-t from-brand-dark/60 via-transparent to-brand-dark/40" data-id="element-208" />

        {/* Subtle film grain / vignette */}
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_transparent_40%,_rgba(0,0,0,0.5)_100%)] pointer-events-none" data-id="element-209" />

        {/* Accent glow */}
        <div className="absolute top-1/3 -left-20 w-[500px] h-[500px] opacity-25 pointer-events-none" data-id="element-210">
          <div className="absolute inset-0 bg-brand-accent blur-[140px] rounded-full mix-blend-screen" data-id="element-211" />
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full" data-id="element-212">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-213">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.3
        }} className="max-w-2xl" data-id="element-214">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-accent/10 border border-brand-accent/20 text-brand-accent text-sm font-medium mb-6 backdrop-blur-sm" data-id="element-215">
              <Star className="w-4 h-4" data-id="element-216" />
              <span data-id="element-217">Diseño Web Estratégico</span>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.1] mb-6 text-balance drop-shadow-[0_2px_20px_rgba(0,0,0,0.6)]" data-id="element-218">
              Tu Próxima Página Web No Solo Se Ve Profesional —{' '}
              <br className="hidden sm:block" data-id="element-219" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-accent via-amber-200 via-orange-400 to-brand-accent bg-[length:200%_auto] animate-gradient-x" data-id="element-220">
                Convierte Visitantes en Clientes Mientras Duermes
              </span>
            </h1>

            <p className="text-lg sm:text-xl text-slate-200 mb-8 leading-relaxed drop-shadow-[0_2px_12px_rgba(0,0,0,0.6)]" data-id="element-221">
              Para emprendedores que saben que valen más de lo que
              están cobrando — y están listos para que el mundo lo vea también.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-10" data-id="element-222">
              <Button href="https://wa.me/56972115173?text=Hola%20Nacho%2C%20quiero%20mi%20web%20profesional" target="_blank" rel="noopener noreferrer" size="lg" icon={<MessageCircle className="w-5 h-5" data-id="element-224" />} data-id="element-223">
                Quiero Mi Web Profesional
              </Button>
              <Button href="#solucion" variant="outline" size="lg" icon={<ArrowRight className="w-5 h-5" data-id="element-226" />} data-id="element-225">
                Ver Cómo Funciona
              </Button>
            </div>

            <div className="flex items-center gap-6 text-sm text-slate-300 border-t border-white/10 pt-6" data-id="element-227">
              <div className="flex items-center gap-2" data-id="element-228">
                <Users className="w-5 h-5 text-brand-accent" data-id="element-229" />
                <span data-id="element-230">
                  <strong className="text-white" data-id="element-231">+1000</strong> Emprendedores Ayudados
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-232">
                <Star className="w-5 h-5 text-brand-accent" data-id="element-233" />
                <span data-id="element-234">
                  <strong className="text-white" data-id="element-235">+3 Años</strong> Experiencia
                </span>
              </div>
            </div>
          </motion.div>

          {/* Right column intentionally empty — subject lives in the background image */}
          <div className="hidden lg:block" data-id="element-236" />
        </div>
      </div>
    </section>;
}